import { IAuthRepository } from '../../domain/repositories/IAuthRepository';
import { RegisterRequestDTO, RegisterResponseDTO } from '../dto/RegisterDTO';
import { UserMapper } from '../mappers/UserMapper';

/**
 * Register Use Case
 * Handles user registration with email and password
 */
export class RegisterUseCase {
  constructor(private readonly authRepository: IAuthRepository) {}

  async execute(request: RegisterRequestDTO): Promise<RegisterResponseDTO> {
    const user = await this.authRepository.register(
      request.email,
      request.password,
      request.fullName,
      request.role,
      request.workspaceId
    );

    return {
      user: UserMapper.toDTO(user),
      message: 'Usuario registrado exitosamente',
    };
  }
}
